exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{background-color:#e7d7cc}.fuller{height:calc(100% - 110px)}#app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fadein-enter-active,.fadein-leave-active{position:absolute;top:0;left:0;width:100%;min-height:100%;-webkit-transition:opacity 1s;transition:opacity 1s;opacity:1}.fadein-enter,.fadein-leave-to{opacity:0}::-moz-selection{color:#fce6e6;background:rgba(240,159,93,.685)}::selection{color:#fce6e6;background:rgba(240,159,93,.685)}", ""]);

// exports
